import React from 'react'
import {
  AuditOutlined,
  CalendarOutlined,
  FacebookFilled,
  GlobalOutlined,
  LinkOutlined,
  MessageOutlined,
  ShopOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'

import { RitaIntegration } from '@/components/rita-integration'
import { WhatsappIntegration } from '@/components/whatsapp-integration'
import { AgendorIntegration } from '@/components/agendor-integration'
import CalendarIntegration from '@/components/calendar-integration'
import EvolutionIntegration from '@/components/evolution-integration'
import { ChatIntegration } from '@/components/chat-integration'
import { CatalogIntegration } from '@/components/catalog-integration'
import { CRMIntegration } from '@/components/crm-integration'
import { EvoCRMIntegration } from '@/components/evo-crm-integration'
import { RDStationIntegration } from '@/components/rd-station-integration'
import { PipedriveIntegration } from '@/components/pipedrive-integration'
import { MetaPixelIntegration } from '@/components/meta-pixel-integration'
import { FeegowIntegration } from '@/components/feegow-integration'
import { AdminRole, EditorRole, OwnerRole } from '@/constants.js'

export const INTEGRATIONS = [
  {
    label: 'Link externo',
    description: 'Exponha seu assistente externamente',
    icon: <GlobalOutlined />,
    type: 'rita',
    Component: RitaIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Whatsapp (Oficial)',
    description: 'Publique seu chat no whatsapp',
    icon: <WhatsAppOutlined />,
    type: 'whatsapp',
    Component: WhatsappIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Whatsapp (Evolution-Api)',
    description: 'Conecte seu whatsapp no assistente usando a evolution',
    icon: <WhatsAppOutlined />,
    type: 'evolution',
    Component: EvolutionIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Agendor (Agendor)',
    description: 'Realize integrações com seu CRM agendor',
    icon: <LinkOutlined />,
    type: 'agendor',
    Component: AgendorIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Agendamento (Google Agenda)',
    description: 'Realize integração com o Google Agenda',
    icon: <CalendarOutlined />,
    type: 'calendar',
    Component: CalendarIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Chat de atendimento',
    description:
      'Tenha uma integração de atendimento em chat na Livia. Adicione um copiloto.',
    icon: <MessageOutlined />,
    type: 'chat',
    Component: ChatIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Integração de catálogo',
    description: 'Cadastre, edite, adicione e pesquise items na Lívia',
    icon: <ShopOutlined />,
    type: 'catalog',
    Component: CatalogIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'CRM',
    description:
      'Instale o CRM nativo da Livia. (Contatos, Negócios, Tarefas e Funils)',
    icon: <AuditOutlined />,
    type: 'crm',
    Component: CRMIntegration,
    roles: [AdminRole],
  },
  {
    label: 'Evo CRM',
    description: 'Instale o Evo CRM',
    icon: <LinkOutlined />,
    type: 'evo-crm',
    Component: EvoCRMIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'RD Station',
    description: 'Instale o RD Station',
    icon: <LinkOutlined />,
    type: 'rd-station',
    Component: RDStationIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Pipedrive',
    description: 'Instale o Pipedrive',
    icon: <LinkOutlined />,
    type: 'pipedrive',
    Component: PipedriveIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Meta Ads',
    description: 'Integre com o Pixel via Meta Ads',
    icon: <FacebookFilled />,
    type: 'meta-pixel',
    Component: MetaPixelIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
  {
    label: 'Feegow',
    description:
      'Integre com sua clínica no Feegow para gestão de pacientes e agendamentos',
    icon: <LinkOutlined />,
    type: 'feegow',
    Component: FeegowIntegration,
    roles: [AdminRole, OwnerRole, EditorRole],
  },
]

export function getIntegrationByType(type) {
  return INTEGRATIONS.find((i) => i.type === type)
}

export function getIntegrationsForRole(role) {
  return INTEGRATIONS.filter((i) => i.roles.includes(role))
}

export function IntegrationRenderer({
  type,
  assistantID,
  chatbotID,
}) {
  const item = getIntegrationByType(type)
  if (!item) return null
  const Comp = item.Component
  return (
    <Comp
      {...item}
      assistantID={assistantID}
      chatbotID={chatbotID}
    />
  )
}
